export default "__VITE_ASSET__CaWIXaTD__"